import { NavLink } from "react-router-dom";
import type { ChapterDto } from "@mmm/contracts";
import { ColorDot } from "@mmm/ui";
export function SidebarChapterRow({ chapter }: { chapter: ChapterDto }) {
  return (
    <div className="mmm-sidebar-chapter-row">
      <NavLink
        to={`/subjects/${chapter.subjectId}/chapters/${chapter.id}`}
        className={({ isActive }) => `mmm-sidebar-tree-row ${isActive ? "is-active" : ""}`.trim()}
      >
        <ColorDot color="var(--mmm-gold-word)" size={6} className="mmm-sidebar-chapter-dot" />
        <span>{chapter.title}</span>
      </NavLink>
    </div>
  );
}
